module.exports = __webpack_public_path__ + "img/libra.da2cc527.png";